import React from 'react'
import css from '@emotion/css'

import ArrowSvg from '../images/arrow.inline.svg'

const Arrow = ({ fill, customCss, speed }) => {
    return (
        <span
            className="arrow"
            css={[arrowClassFn({ fill, speed }), customCss]}
        >
            <ArrowSvg />
        </span>
    )
}

const arrowClassFn = (props = {}) => css`
    display: inline-block;
    margin-right: 0.3em;
    position: relative;
    top: -1px;
    transition: transform 0.4s linear;
    vertical-align: middle;
    width: 8px;

    * {
        fill: ${props.fill || 'white'} !important;
        transition: fill 0.1s linear ${props.speed ? '0' : '0.15'}s;
    }
`

export default Arrow
